import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router";

export function AdminGuard() {
  const navigate = useNavigate();
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    fetch("/api/auth/check", { credentials: "include" })
      .then((res) => {
        if (res.ok) {
          setAllowed(true);
        } else {
          navigate("/admin-login", { replace: true });
        }
      })
      .catch(() => navigate("/admin-login", { replace: true }));
  }, [navigate]);

  if (!allowed) return null;
  return <Outlet />;
}
